"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

require("../../../global-files/global-styles.css");

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  background-color: #f0eef2;\n  border-radius: 3px;\n  display: flex;\n  width: fit-content;\n  height: 26px;\n  padding: 5px;\n  align-items: center;\n\n  .feature-name {\n    font-size: 14px;\n    font-family: ", ";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 18px;\n    color: ", ";\n\n    & + * {\n      margin-left: 5px;\n    }\n  }\n  .feature-value {\n    font-family: ", ";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    height: 12px;\n    letter-spacing: -0.015em;\n    color: ", ";\n  }\n\n  &:last-of-type {\n    p {\n      font-size: 24px;\n    }\n  }\n"])), _variables.FontFamily.Raleway_500, _variables.GlobalColors.original_magenta, _variables.FontFamily.AvenirNext, _variables.GlobalColors.s4);

exports.Container = Container;